import React, { Component } from "react";
import { connect } from "react-redux";
import RouteMenu from "VENDOR/CommonResources/RoutingMenu/RouteMenu";
import "../VendorQuotation/VendorQuotation.scss";
import print from "../../CommonResources/print.png";
import expo from "../../CommonResources/export.png";
import invoiceB from "../../CommonResources/invoiceB.png";
import status from "../../CommonResources/status.png";
import requested from "../../CommonResources/requested.png";
import expected from "../../CommonResources/expected.png";
import timer from "../../CommonResources/timer.png";
import insititute from "../../CommonResources/insititute.png";
import { ToastContainer, toast } from "react-toastify";
import config from "config";
import vendorApiCall from "vendorApiCall";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonLoader from "VENDOR/CommonResources/ButtonLoader/ButtonLoader";
import ExportJsonButton from "VENDOR/CommonResources/export/ExportExcelButton";
import Pagination from "react-js-pagination";
import * as XLSX from "xlsx";
import ReactToPrint from "react-to-print";
let apiPath = "/vendor/api/vendor.php";

const pageStyle = `
  @media print {
    @page {
      size: landscape;
      margin: 0.5cm;
    }

    body {
      font-size: 12px;
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }

    th, td {
      border: 1px solid #000;
      padding: 4px;
      text-align: left;
    }

    tr {
      page-break-inside: avoid;
    }

    .hidden-export-row {
      display: table-row !important;
    }

    input, select, button {
      display: none !important;
    }

    .icon-button, .pagination, .btn-submit, .btn-cancel, .quotation-input {
      display: none !important;
    }
  }
`;
class VendorQuotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      filterText: "",
      statusFilter: localStorage.getItem("quotations_filter") || "",
      showModal: false,
      selectedRow: null,
      modalTableData: [],
      isLoading: false,
      errorMessage: "",
      updateLoading: false,
      isSaveLoading: false,
      isSendLoading: false,
      iidArray: this.props.iidArray,
      iidDetails: {},
      activePage: 1,
      itemsPerPage: 10,
      totalItemsCount: 0,
      selectedInstitute: "",
      exportDetails:false,
    };
  }

  componentDidMount() {
    if (
      this.props.iidArray.length > 0
     ) {
       this.setState(
         {
           iidArray: this.props.iidArray,
         },
         () => {
           this.fetchQuotation();
         }
       );
     }

   
     localStorage.setItem(`quotations_filter`,"");
    

  }
  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.iidArray) !=
        JSON.stringify(prevProps.iidArray) ||
      JSON.stringify(this.props.iidDetails) !=
        JSON.stringify(prevProps.iidDetails)
    ) {
      this.setState(
        {
          iidArray: this.props.iidArray,
        },
        () => {
          this.fetchQuotation();
        }
      );
    }
  }

  fetchQuotation = async () => {
    this.setState({ isLoading: true,tableData:[] });

    const offset = (this.state.activePage - 1) * this.state.itemsPerPage;

    //this.props.iidDetails[iid].details.vendorId
    const vendorArray = Object.keys(this.props.iidDetails)
      .map((iid) => {
        const details = this.props.iidDetails[iid]?.details;
        return details?.vendorId || null;
      })
      .filter(Boolean);

    const requestData = {
      iidArray: this.state.iidArray,
      vendorIdArray: vendorArray,
      status: this.state.statusFilter,
      filterText: this.state.filterText,
      limit: this.state.itemsPerPage,
      offset,
    };

    let jsonResponse = await vendorApiCall.makeApiCall(
      "inventory_getQuotationsRecievedToVendor",
      requestData,
      apiPath
    );
    const response = jsonResponse?.APIResult || {};

    if (response.success === "true") {
      let rawData = response.data;
      // Convert object to array, reverse it, and map back to the required format
      const formattedData = Object.keys(rawData)
        .reverse()
        .map((key, index) => {
          const item = rawData[key];

          return {
            srNo: ((this.state.activePage - 1) * this.state.itemsPerPage) + index + 1,
            quotationNumber: item.quotationNumber || "-",
            prName: item.prName,
            prNumber: item.prNumber,
            prId: item.prId,
            iid: item.iid,
            instituteName: item.instituteName,
            requestedBy: item.requestedByName,
            prVendorId: item.prVendorId,
            vendorId: item.vendorId,
            requestedOn: item.requestedOn,
            expectedOn: item.expectedOn,
            countDown: this.calculateCountdown(item.expectedOn),
            status: item.status,
            action:
              item.status === "pending" || item.status === "shared"
                ? "Fill Quotation"
                : "View",
          };
        });

      this.setState({
        tableData: formattedData,
        totalItemsCount: response.totalCount,
      });
    }
    this.setState({ isLoading: false });
  };

  calculateCountdown = (expectedDate) => {
    const currentDate = new Date();
    const targetDate = new Date(expectedDate);

    const differenceInMs = targetDate - currentDate;
    const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

    if (differenceInDays < 0) {
      return "Expired";
    } else if (differenceInDays === 0) {
      return "Today";
    } else {
      return `Within ${differenceInDays} Days`;
    }
  };

  handleFilterChange = (e) => {
    this.setState({ filterText: e.target.value, activePage: 1, offset:0 }, this.fetchQuotation);
  };

  handleInstituteChange = (e) => {
    const selected = e.target.value;

    let updatedArray = selected === "" ? this.props.iidArray : [selected];

    this.setState(
      {
        selectedInstitute: selected,
        iidArray: updatedArray,
        activePage: 1, offset:0
      },
      () => {
        this.fetchQuotation();
      }
    );
  };

  handleStatusChange = (e) => {
    this.setState({ statusFilter: e.target.value, activePage: 1, offset:0 }, this.fetchQuotation);
  };

  formatDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);

    if (isNaN(date)) {
      return "Invalid Date";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  openFillQuotationModal = async (row) => {
    this.setState({
      showModal: true,
      selectedRow: row,
      modalTableData: [],
      isLoading: true,
      quotationNumber: "",
      selectedInstitute: row.iid,
    });

    const requestData = {
      vendorId: row.vendorId,
      prVendorId: row.prVendorId,
    };

    let jsonResponse = await vendorApiCall.makeApiCall(
      "inventory_getQuotationDetailsRecivedToVendors",
      requestData,
      apiPath
    );

    const response = jsonResponse?.APIResult || {};

    if (response.success === "true") {
      const modalData = Object.values(response.data).map((item, index) => ({
        srNo: index + 1,
        ...item,
      }));

      this.setState({
        modalTableData: modalData,
        quotationNumber: response.quotationNumber,
      });
    }
    this.setState({ isLoading: false });
  };

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber }, this.fetchQuotation);
  };

  closeModal = () => {
    this.setState({ showModal: false, selectedRow: null, modalTableData: [] });
  };

  handleInputChange = (e, rowId, field) => {
    const value = parseFloat(e.target.value) || 0;

    this.setState((prevState) => {
      const updatedModalTableData = prevState.modalTableData.map((row) => {
        if (row.uniqueId === rowId) {
          const updatedRow = { ...row, [field]: value };

          if (["amountPerUnit", "discount", "tax"].includes(field)) {
            const amount = parseFloat(updatedRow.amountPerUnit) || 0;
            const discount = parseFloat(updatedRow.discount) || 0;
            const tax = parseFloat(updatedRow.tax) || 0;
            const quantity = parseFloat(updatedRow.expectedQuantity) || 1;

            //after discount
            const discountedAmount = amount - (amount * discount) / 100;

            updatedRow.applicableAmount =
              parseFloat(
                (discountedAmount + (discountedAmount * tax) / 100).toFixed(2) *
                  quantity
              ) || 0;
          }

          return updatedRow;
        }
        return row;
      });

      return { modalTableData: updatedModalTableData };
    });
  };

  handleModalSubmit = async (actionType) => {
    const { modalTableData, quotationNumber, selectedRow } = this.state;
   

    const isSave = actionType === "save";
    const isSend = actionType === "send";

    this.setState({
      isSaveLoading: isSave,
      isSendLoading: isSend,
    });

    // Validate quotation number
    if (!quotationNumber.trim()) {
      toast.error("Please Enter Quotation Number.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      this.setState({
        isSaveLoading: false,
        isSendLoading: false,
      });
      return;
    }

    const hasInvalidValues = modalTableData.some((row) => {
      const amount = parseFloat(row.amountPerUnit) || 0;

      return amount === 0;
    });

    if (hasInvalidValues) {
      toast.error("Amount Per Unit must be greater than zero.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      this.setState({
        isSaveLoading: false,
        isSendLoading: false,
      });
      return;
    }

    const quotation = modalTableData.reduce((acc, row) => {
      acc[row.uniqueId] = {
        amountPerUnit: parseFloat(row.amountPerUnit) || 0,
        applicableAmount: parseFloat(row.applicableAmount) || 0,
        taxApplicable: parseFloat(row.tax) || 0,
        discount: parseFloat(row.discount) || 0,
        uniqueId: row.uniqueId,
      };
      return acc;
    }, {});

    const requestData = {
      iid: selectedRow.iid,
      vendorId: selectedRow.vendorId,
      prId: selectedRow.prVendorId,
      quotationStatus: isSend ? "shared" : "inprogress",
      quotation,
      quotationNumber,
    };

    try {
      const response = await vendorApiCall.makeApiCall(
        "inventory_updateVendorQuotation",
        requestData,
        apiPath
      );
      if (isSave) {
        toast.success("You have successfully saved the quotation details.");
      } else {
        toast.success(
          "You have successfully sent the quotation details to faculty"
        );
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      this.setState({
        isSaveLoading: false,
        isSendLoading: false,
        showModal: false,
      });
    }
  };

  getInstituteLogoByIid = (iid )=>{
    return this.props.iidDetails[iid].details.logo;  
  }
  
  renderModal = () => {
    const {
      showModal,
      modalTableData,
      isLoading,
      quotationNumber,
      updateLoading,
      isSaveLoading,
      isSendLoading,
    } = this.state;

    if (!showModal) return null;

    return (
      <div className="quotation-modal">
        <div className="quotation-modal-content modalDataContainer">
          {/* Modal Header */}
          <div
            className="modal-header"
            style={{
              color: "#202020",
              background: "white",
              border: "none",
              cursor: "pointer",
            }}
          >
            <h3>Fill Quotation</h3>

              <div>
                <ReactToPrint
                  trigger={() => 
                    <button  className="icon-button">
                      <img src={print} alt="Print Icon"   />
                    
                    </button>
                  }
                  pageStyle={pageStyle}
                  content={() => this.tableRef}
                  />

                <button
                  aria-label="Print"
                  className="icon-button"
                  onClick={this.handleExport}
                  title="Click here to export the entries to excel file"

                >
                  <img src={expo} alt="Export" />
                </button>

                {/* <ExportJsonButton
                data={modalTableData}
                quotation={quotationNumber}
              /> */}

              <FontAwesomeIcon
                icon={["fas", "times"]}
                onClick={this.closeModal}
              />
                </div>
            </div>
     

          {/* Modal Body */}
          <div className="modal-body ">
            {isLoading ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <ButtonLoader />
                <span>Loading...</span>
              </div>
            ) : (
              <>
                <div className="info-bar">
                <div className="info-right">
                      <div className="info-block">
                        <div className="icon-circle">
                          <img
                            src={this.getInstituteLogoByIid(this.state.selectedRow.iid)}
                            alt="Institute name"
                            style={{
                              height:'25px',
                              width:'25px',
                              borderRadius:'50%'
                            }}

                          />
                        </div>
                        <div>
                          <p className="small-text">Institute name</p>
                          <p className="bold-text">{this.state.selectedRow.instituteName}</p>
                        </div>
                      </div>

                      <div className="info-block">
                        <div className="icon-circle">
                          <img src={invoiceB} alt="Purchase Request Details" />
                        </div>
                        <div>
                          <p className="small-text">Purchase Request Details</p>
                          <p
                            className="bold-text"
                            title={this.state.selectedRow.prNumber + this.state.selectedRow.prName}
                          >
                            {(
                              this.state.selectedRow.prNumber + this.state.selectedRow.prName
                            ).length > 25
                              ? (this.state.selectedRow.prNumber + this.state.selectedRow.prName).substring(0, 25) + "..."
                              : this.state.selectedRow.prNumber + this.state.selectedRow.prName}
                          </p>
                        </div>
                      </div>

                      <div className="info-block">
                        <div className="icon-circle">
                          <img src={requested} alt="Requested On" />
                        </div>
                        <div>
                          <p className="small-text">Requested On</p>
                          <p className="bold-text">{this.formatDate(this.state.selectedRow.requestedOn)}</p>
                        </div>
                      </div>

                      <div className="info-block">
                        <div className="icon-circle">
                          <img src={expected} alt="Expected On" />
                        </div>
                        <div>
                          <p className="small-text">Expected On</p>
                          <p className="bold-text">{this.formatDate(this.state.selectedRow.expectedOn)}</p>
                        </div>
                      </div>

                      <div className="info-block">
                        <div className="icon-circle">
                          <img src={timer} alt="Count Down" />
                        </div>
                        <div>
                          <p className="small-text">Count Down</p>
                          <p className="bold-text">
                            {this.calculateCountdown(this.state.selectedRow.expectedOn)}
                          </p>
                        </div>
                      </div>

                      <div className="info-block">
                        <div className="icon-circle">
                          <img src={status} alt="Current Status" />
                        </div>
                        <div>
                          <p className="small-text">Current Status</p>
                          <p
                            className={`status ${this.state.selectedRow.status}`}
                            style={{marginBottom:'0px', fontSize:'14px'}}
                          >
                           {this.state.selectedRow.status == "inprogress"
                          ? "In progress"
                          : this.state.selectedRow.status.charAt(0).toUpperCase() +
                          this.state.selectedRow.status.slice(1)}
                          </p>
                          
                        </div>
                      </div>
                    </div>
                </div>
                <table className="quotation-table" id="quotation-table-export" ref={(ref) => (this.tableRef = ref)}>
                  <thead>
                  <tr
                    className="hidden-export-row"
                   
                  >
                    <th colSpan="8" >
                        <p style={{
                          display:"flex",
                          justifyContent:"center",
                          textAlign: "center",
                          verticalAlign: "middle",
                          fontWeight: "bold",
                          fontSize: "16px",
                          margin:"auto 0"

                          
                        }}>Quotation </p>
                    </th>
                </tr>
                <tr
                    className="hidden-export-row"
                   
                  >
                    <th colSpan="7" >
                        <p style={{
                          display:"flex",
                          justifyContent:"center",
                          textAlign: "center",
                          verticalAlign: "middle",
                          fontWeight: "bold",
                          fontSize: "16px",
                          margin:"auto 0"
                          
                        }}>Quotation Number : {this.state.quotationNumber}</p>
                    </th>
                </tr>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Asset Name</th>
                      <th>Asset Type</th>
                      <th>Expected Quantity</th>
                      <th>Amount Per Unit</th>
                      <th>Discount (%)</th>
                      <th>Select Tax (%)</th>
                      <th>Applicable Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalTableData.map((row) => (
                      <tr key={row.uniqueId}>
                        <td>{row.srNo}</td>
                        <td>{row.catalogueName || "N/A"}</td>
                        <td>{row.catalogueType || "N/A"}</td>
                        <td>{row.expectedQuantity || "N/A"}</td>
                        <td>
                          <input
                            type="number"
                            defaultValue={row.actualAmount}
                            onChange={(e) =>
                              this.handleInputChange(
                                e,
                                row.uniqueId,
                                "amountPerUnit"
                              )
                            }
                            placeholder="Enter Amount"
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+" 
                               
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          <p  className="hidden-export-row" > {row.actualAmount}</p>
                        </td>
                        <td>
                          <input
                            type="number"
                            defaultValue={row.discountedAmount}
                            onChange={(e) =>
                              this.handleInputChange(
                                e,
                                row.uniqueId,
                                "discount"
                              )
                            }
                            placeholder="Enter Discount"
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                          <p  className="hidden-export-row" > {row.discountedAmount}</p>

                        </td>
                        <td>
                          {this.state.exportDetails ?  <p  className="hidden-export-row" > {row.tax}</p> : <>
                            <select
                              value={row.tax || ""}
                              onChange={(e) =>
                                this.handleInputChange(e, row.uniqueId, "tax")
                              }
                            >
                              <option value={0}>0% Tax</option>
                              <option value={18}>18.0% IGST (18%)</option>
                              {/* <option value={0}>Out of Scope (0%)</option>
                              <option value={0}>0% GST (0%)</option> */}
                              <option value={6}>6.0% IGST (6%)</option>
                              <option value={28}>28.0% IGST (28%)</option>
                              <option value={28}>28.0% GST (28%)</option>
                              <option value={12}>12.0% GST (12%)</option>
                              <option value={18}>18.0% GST (18%)</option>
                              <option value={3}>3.0% GST (3%)</option>
                              <option value={0.25}>0.25% IGST (0.25%)</option>
                              <option value={5}>5.0% GST (5%)</option>
                              <option value={6}>6.0% GST (6%)</option>
                              <option value={0.25}>0.25% GST (0.25%)</option>
                              {/* <option value={0}>Exempt IGST (0%)</option> */}
                              <option value={3}>3.0% IGST (3%)</option>
                              <option value={5}>5.0% IGST (5%)</option>
                              {/* <option value={0}>Exempt GST (0%)</option> */}
                              <option value={12}>12.0% IGST (12%)</option>
                            </select>
                          
                          </>}
                         
                        </td>
                        <td className="applicable-amount">
                          { parseFloat(row.applicableAmount.toFixed(4)) || 0}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>

          {/* Modal Footer */}
          <div className="modal-footer" style={{ justifyContent: "flex-end" }}>
            <p>
              Quotation Number : <span style={{ color: "red" }}> *</span>
            </p>
            <input
              className="quotation-input"
              type="text"
              placeholder="Enter Quotation No."
              value={quotationNumber}
              maxLength={20}
              onChange={(e) =>
                this.setState({ quotationNumber: e.target.value })
              }
            />

            <button
              className="btn-cancel"
              onClick={this.closeModal}
              disabled={isSaveLoading || isSendLoading}
            >
              Cancel
            </button>

            <button
              className="btn-submit"
              disabled={
                isSaveLoading ||
                isSendLoading ||
                this.state.selectedRow.status === "locked" ||
                (this.state.selectedRow.status !== "locked" &&
                  this.calculateCountdown(this.state.selectedRow.expectedOn) ===
                    "Expired")
              }
              onClick={() =>
                this.handleModalSubmit(
                  this.state.selectedRow.status == "shared" ? "send" : "save"
                )
              }
              style={{
                display: "flex",
                alignItems: "center",
                background:
                  this.state.selectedRow.status === "locked"
                    ? "#ccc"
                    : this.calculateCountdown(
                        this.state.selectedRow.expectedOn
                      ) === "Expired"
                    ? "#f5f5f5"
                    : "#E0E5EB",
                color:
                  this.state.selectedRow.status === "locked"
                    ? "#888"
                    : this.calculateCountdown(
                        this.state.selectedRow.expectedOn
                      ) === "Expired"
                    ? "#aaa"
                    : "#2D4969",
              }}
            >
              {isSaveLoading && <ButtonLoader />}
              {isSaveLoading
                ? ""
                : this.state.selectedRow.status === "locked"
                ? "Locked"
                : this.calculateCountdown(this.state.selectedRow.expectedOn) ===
                  "Expired"
                ? "Expired"
                : "Save"}
            </button>

            <button
              className="btn-submit"
              disabled={
                isSaveLoading ||
                isSendLoading ||
                this.state.selectedRow.status === "locked" ||
                (this.state.selectedRow.status !== "locked" &&
                  this.calculateCountdown(this.state.selectedRow.expectedOn) ===
                    "Expired")
              }
              onClick={() => this.handleModalSubmit("send")}
              style={{
                display: "flex",
                alignItems: "center",
                background:
                  this.state.selectedRow.status === "locked"
                    ? "#ccc"
                    : this.calculateCountdown(
                        this.state.selectedRow.expectedOn
                      ) === "Expired"
                    ? "#f5f5f5"
                    : "#E0E5EB",
                color:
                  this.state.selectedRow.status === "locked"
                    ? "#888"
                    : this.calculateCountdown(
                        this.state.selectedRow.expectedOn
                      ) === "Expired"
                    ? "#aaa"
                    : "#2D4969",
              }}
            >
              {isSendLoading && <ButtonLoader />}
              {isSendLoading
                ? ""
                : this.state.selectedRow.status === "locked"
                ? "Locked"
                : this.calculateCountdown(this.state.selectedRow.expectedOn) ===
                  "Expired"
                ? "Expired"
                : "Send"}
            </button>
          </div>
        </div>
      </div>
    );
  };



  exportRenderedTableToExcel = () => {
    const originalTable = this.tableRef;
  
    if (!originalTable) {
      toast.error("Table not found.");
      return;
    }
  

    const clonedTable = originalTable.cloneNode(true);
  
    const hiddenRows = clonedTable.querySelectorAll(".hidden-export-row");
    hiddenRows.forEach((row) => {
      row.style.display = "table-row";
    });
  

    clonedTable.style.position = "absolute";
    clonedTable.style.left = "-9999px";
    document.body.appendChild(clonedTable);
  
    const wb = XLSX.utils.table_to_book(clonedTable, { sheet: "Quotations" });
    XLSX.writeFile(wb, "Quotations List.xlsx");
  
    document.body.removeChild(clonedTable);
  };
  
    handleExport = () => {
      this.setState({exportDetails:true}, ()=> {this.exportRenderedTableToExcel(); this.setState({exportDetails:false}) });
    };

  render() {
    const { isLoading } = this.state;
    return (
      <div>
        <RouteMenu />
        <div className="modalDataContainer">

        <div className="quotation-main">
          <div className="quotation-header">
            Quotation
            <p style={{ fontSize: "12px" }}>
              You can request the vendor to fulfill the quotation.
            </p>
          </div>
          <div
            className="seprator"
            style={{
              borderBottom: "1px solid #AAAAAA",
              height: "3px",
              width: "100%",
              marginBottom: "15px",
            }}
          ></div>
          <div className="quotation-filter">
            <div className="filters">
              <input
                type="text"
                placeholder="Search by Quotation ID or Quotation Name"
                value={this.state.filterText}
                onChange={this.handleFilterChange}
              />
              <select
                onChange={this.handleInstituteChange}
                value={this.state.selectedInstitute}
              >
                <option value="">All Institute</option>
                {Object.entries(this.props.iidDetails).map(([key, value]) => (
                  <option key={key} value={key}>
                    {value.details.instituteName}
                  </option>
                ))}
              </select>
              <select
                onChange={this.handleStatusChange}
                value={this.state.statusFilter}
              >
                <option value="">All Status</option>
                <option value="pending">Pending</option>
                <option value="inprogress">In progress</option>
                <option value="shared">Shared</option>
                <option value="locked">Locked</option>
              </select>
            </div>
            <div>
             
              <ReactToPrint
                trigger={() => 
                  <button  className="icon-button">
                    <img src={print} alt="Print Icon"   />
                   
                  </button>
                }
                pageStyle={pageStyle}
                content={() => this.tableRef}
                />

              <button
                aria-label="Print"
                className="icon-button"
                onClick={this.handleExport}
                title="Click here to export the entries to excel file"
              >
                <img src={expo} alt="Export" />
              </button>
            </div>
          </div>

          <div  className="clear-filters">
          <p>{(this.state.filterText !== "" || this.state.statusFilter !==  "" || this.state.selectedInstitute !=="") ? "Filters are applied.": ""}</p>
          
          <div
            style={{
              color:'#007bff',
              cursor:'pointer'
            }}
            onClick={() =>
              this.setState(
                { filterText: "", statusFilter: "", selectedInstitute:"", iidArray:this.props.iidArray, activePage: 1, offset:0 },
                this.fetchQuotation
              )
            }
          >
            <u>Clear All</u>
          </div>
        </div>
         

          <div className="table-scroll-container" >
            <table  ref={(ref) => (this.tableRef = ref)} className="quotation-table print-container">
              <thead>
               
                <tr
                    className="hidden-export-row"
                   
                  >
                    <th colSpan="10" >
                        <p style={{
                          display:"flex",
                          justifyContent:"center",
                          textAlign: "center",
                          verticalAlign: "middle",
                          fontWeight: "bold",
                          fontSize: "16px",
                          
                        }}>Quotations List</p>
                    </th>
                </tr>

                {(this.state.filterText || this.state.statusFilter || this.state.selectedInstitute) && (
                    <tr className="hidden-export-row">
                      <th colSpan="9">
                        {this.state.filterText && `Quotation Number: ${this.state.filterText}`}
                        {this.state.statusFilter && ` | Status: ${this.state.statusFilter}`}
                        {this.state.selectedInstitute &&
                          ` | Institute: ${
                            this.props.iidDetails[this.state.selectedInstitute]?.details
                              ?.instituteName || this.state.selectedInstitute
                          }`}
                      </th>
                    </tr>
                  )}
                <tr>
                  <th>Sr. No.</th>
                  <th>Quotation Number</th>
                  <th>PR Name</th>
                  <th>Institute Name</th>
                  <th>Requested By</th>
                  <th>Requested On</th>
                  <th>Expected On</th>
                  <th>Count Down</th>
                  <th>Status</th>
                  <th className="hidePrint">Action</th>
                </tr>
              </thead>
              <tbody>
                {this.state.tableData.length > 0 ? (
                  this.state.tableData.map((row, index) => (
                    <tr key={index}>
                      <td>{row.srNo}</td>
                      <td>{row.quotationNumber}</td>
                      <td>{row.prName}</td>
                      <td>{row.instituteName}</td>
                      <td>{row.requestedBy}</td>
                      <td>{this.formatDate(row.requestedOn)}</td>
                      <td>{this.formatDate(row.expectedOn)}</td>
                      <td
                        className={`status ${
                          row.countDown === "Expired" ||
                          row.countDown === "Today"
                            ? "rejected"
                            : ""
                        }`}
                      >
                        {row.countDown}
                      </td>
                      <td className={`status ${row.status.toLowerCase()}`}>
                        {row.status == "inprogress"
                          ? "In progress"
                          : row.status.charAt(0).toUpperCase() +
                            row.status.slice(1)}
                      </td>
                      <td
                        className="action hidePrint"
                      >
                        {row.countDown === 'Expired' ? "":<p  onClick={() => this.openFillQuotationModal(row)}>{row.action}</p>}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="10"
                      style={{ textAlign: "center", fontStyle: "italic" }}
                    >
                      {isLoading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <ButtonLoader />
                          <span style={{ marginLeft: "10px" }}>Loading...</span>
                        </div>
                      ) : <p>{(this.state.filterText !== "" || this.state.statusFilter !==  "" || this.state.selectedInstitute !=="") ? "No quotations available as per applied filters.": "No quotations available."}</p>}
                      
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Component */}

          {
                            this.state.totalItemsCount  > 0 &&
                            <div className="" style={{ marginTop: '2%' }}>
                                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15, marginTop: "1rem" }}>
                                    <div ref={this.dropdownRef} className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold", paddingLeft: '0px' }}>

                                        <select
                                            className={`dropdown ${this.state.dropdownDirection}`}
                                            value={this.state.itemsPerPage}
                                            onChange={(e) =>
                                              this.setState(
                                                {
                                                  itemsPerPage:e.target.value,
                                                  activePage: 1,
                                                },
                                                this.fetchQuotation
                                              )
                                            }
                                        >
                                            <option value={10} className='entryFont'>Entries Per Page 10</option>
                                            <option value={25} className='entryFont'>Entries Per Page 25</option>
                                            <option value={40} className='entryFont'>Entries Per Page 40</option>
                                            <option value={100} className='entryFont'>Entries Per Page 100</option>
                                            <option value={250} className='entryFont'>Entries Per Page 250</option>
                                        </select>

                                    </div>

                                    {
                                       
                                        <div className="pagignation">
                                            <Pagination
                                                itemsCountPerPage={this.state.itemsPerPage}
                                                totalItemsCount={this.state.totalItemsCount}
                                                pageRangeDisplayed={5}
                                                onChange={this.handlePageChange}
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                activeClass="active"
                                                prevPageText="‹"
                                                nextPageText="›"
                                                firstPageText="«"
                                                lastPageText="»"
                                                activePage = {this.state.activePage}
                                            />
                                            
                                        </div>
                                    }

                                    <p className="" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalItemsCount} </p>
                                </div>
                            </div>
                        }
          <ToastContainer theme="light" />
        </div>
        {this.renderModal()}
      </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  iidArray: store.RouteMenuReducer.assignedIIDArray,
  iidDetails: store.RouteMenuReducer.assignedIIDDetails,
});

export default connect(mapStateToProps)(VendorQuotation);
